// latest: wjk 2017-12-21 9:36 AM
import { Collection } from 'common'
import 'model/proClassification'
Collection.define('collection.filterProClassification', {
  model: 'model.proClassification',
  proxy: {
    // get: '/cpu-supplymgr/saleOrg/pageQueryByCondition'
    get: '/yuncai/refer/pageSupplyCategory'
    // loadmethod: 'post',
    // get: '/cpu-basedocrefer/basedocrefer/supplydoc/getsupplydoc'
  }
})

export default Collection.create('collection.filterProClassification')



// WEBPACK FOOTER //
// ./src/data/collection/filterProClassification/index.js